import React, {useContext, useEffect, useState} from 'react';
import {ToolbarContext, ToolbarEntry} from '../../contexts/toolbar-context';
import {Accordion, AccordionDetails, AccordionSummary, Box, TextField} from "@mui/material";
import WaitSpinner from "../../components/wait-spinner";
import ContractDocument, {EditLiveToggle} from "../../components/contract/ContractDocument";
import {placeholderTokenContext} from "../../components/contract/tokenRenderer";
import {ContractTemplateType} from "./Editor";

type ContractTemplateFormValue = {
    values: ContractTemplateType,
    initialValues: ContractTemplateType,
    isDirty: boolean,
    status: string,
    errors: Record<string, string>,
    onChange: (evt: {target: {name: string, value: string}}) => void,
    setValue: (name: string, value: unknown) => void,
    handleSubmit: () => void
};

const ContractTemplateForm = ({waiting, diaForm}: {waiting: boolean, diaForm: ContractTemplateFormValue}) => {
    const {values, errors, onChange, setValue, handleSubmit, isDirty, status} = diaForm;
    const toolbarContext = useContext(ToolbarContext);
    const field = {
        onChange: onChange
    };
    const [mode, setMode] = useState<'edit' | 'live'>('edit');
    useEffect(() => {
        const buttons: ToolbarEntry[] = [{
            type: 'button',
            icon: 'save',
            tooltip: 'Save',
            callback: handleSubmit,
            label: 'Save',
            disabled: !isDirty || status != 'ready'
        }];
        toolbarContext.setSecondary({
            primaryUrl: '/database/contracts/',
            title: (values?.name || 'New template'),
            secondary: buttons,
            secondaryUrl: values?.id
        });
    }, [isDirty, status, values?.name, values?.id]);

    const sections = (values?.sections || []).filter(Boolean);

    return (
        <Accordion defaultExpanded={true}>
            {waiting && <WaitSpinner variant="overlay"/>}
            <AccordionSummary>
                <Box sx={{display: 'flex', alignItems: 'center', gap: 1, width: '100%'}}>
                    <span>Contract Template</span>
                    <Box sx={{ml: 'auto'}}>
                        <EditLiveToggle mode={mode} onChange={setMode}/>
                    </Box>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <TextField label="Name" name="name" {...field} value={values?.name ?? ''}
                           error={!!errors?.name} helperText={errors?.name}/>
                <TextField label="Description" name="description" {...field} value={values?.description ?? ''}
                           multiline fullWidth margin="normal"/>
                <Box sx={{mt: 2}}>
                    <ContractDocument
                        value={{sections: sections}}
                        onChange={(value) => setValue('sections', (value.sections || []).filter(Boolean))}
                        mode={mode}
                        readOnly={waiting}
                        tokenContext={placeholderTokenContext()}
                    />
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default ContractTemplateForm;
